const o=10,t=4;export{o as CARDS_LIMIT_CONVERSATION_API,t as CHOICES_LIMIT_CONVERSATION_API};
//# sourceMappingURL=fieldLimitationsConvesationApi.js.map
